import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FootballIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FootballIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 21.9976C6.4873 21.9976 2.00244 17.5132 2.00244 12.0005C2.00244 6.48779 6.48731 2.00244 12 2.00244C17.5127 2.00244 21.9976 6.48779 21.9976 12.0005C21.9976 17.5132 17.5127 21.9976 12 21.9976ZM12 3.00243C7.03858 3.00244 3.00244 7.03857 3.00244 12.0005C3.00244 16.9614 7.03857 20.9976 12 20.9976C16.9614 20.9976 20.9976 16.9614 20.9976 12.0005C20.9976 7.03857 16.9614 3.00243 12 3.00243Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 15.3013C11.897 15.3013 11.794 15.269 11.7061 15.2056L8.81445 13.105C8.63916 12.978 8.56591 12.7524 8.63281 12.5464L9.7373 9.14698C9.80419 8.94093 9.99609 8.80128 10.2129 8.80128H13.7871C14.0039 8.80128 14.1958 8.94093 14.2627 9.14698L15.3672 12.5464C15.4341 12.7524 15.3608 12.978 15.1856 13.105L12.294 15.2056C12.2061 15.2691 12.103 15.3013 12 15.3013ZM9.69629 12.5093L12 14.1831L14.3037 12.5093L13.4238 9.80127H10.5762L9.69629 12.5093Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.7056 18.0366C19.6802 18.0366 19.6543 18.0347 19.6284 18.0308C19.4424 18.0015 19.2881 17.8706 19.23 17.6909L18.1304 14.3062C18.0635 14.1001 18.1367 13.8745 18.312 13.7476L21.2007 11.6489C21.3525 11.5376 21.5557 11.5239 21.7227 11.6079C21.8906 11.6948 21.9956 11.8677 21.9946 12.0562C21.9834 14.1372 21.332 16.1343 20.1113 17.8286C20.0166 17.9605 19.8647 18.0366 19.7056 18.0366ZM19.1939 14.3433L19.854 16.3755C20.4268 15.355 20.7905 14.2407 20.9302 13.0815L19.1939 14.3433Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.5698 6.93017H15.9961C15.7793 6.93017 15.5874 6.79052 15.5205 6.58447L14.416 3.18506C14.3491 2.97901 14.4224 2.75342 14.5977 2.62647C14.7275 2.53174 14.9649 2.45167 15.1172 2.50538C17.0713 3.146 18.7607 4.36378 20.0039 6.02686C20.1011 6.15772 20.1294 6.32666 20.0791 6.48096L20.0454 6.58448C19.978 6.79053 19.7861 6.93017 19.5698 6.93017ZM16.3594 5.93017H18.6279C17.792 5.01415 16.7866 4.28662 15.6626 3.78564L16.3594 5.93017Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.00391 7.22021H4.42969C4.21289 7.22021 4.021 7.08056 3.9541 6.87451L3.85498 6.56885C3.80566 6.41651 3.83203 6.24951 3.92676 6.11963C5.10791 4.50147 6.72461 3.28662 8.60254 2.60791C8.7583 2.55029 8.93164 2.57568 9.06543 2.67236L9.40137 2.91552C9.57715 3.04345 9.65088 3.26904 9.58399 3.47509L8.4795 6.8745C8.41261 7.08055 8.22071 7.22021 8.00391 7.22021ZM5.11719 6.22021H7.64063L8.44483 3.74462C7.15626 4.29931 6.02149 5.14306 5.11719 6.22021Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.29444 18.0366C4.13526 18.0366 3.9834 17.9605 3.88868 17.8286C2.66798 16.1343 2.01661 14.1372 2.00538 12.0562C2.0044 11.8677 2.10938 11.6948 2.27735 11.6079C2.44532 11.5249 2.64698 11.5386 2.79932 11.6489L5.68799 13.7476C5.86328 13.8745 5.93653 14.1001 5.86963 14.3062L4.77002 17.6909C4.71191 17.8706 4.55762 18.0015 4.37158 18.0308C4.3457 18.0347 4.31983 18.0366 4.29444 18.0366ZM3.06983 13.0815C3.20948 14.2407 3.57325 15.355 4.146 16.3755L4.80616 14.3433L3.06983 13.0815Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 21.9976C10.9898 21.9976 9.9917 21.8472 9.0332 21.5493C8.87793 21.5015 8.75586 21.3804 8.70556 21.2261L8.63281 21.0024C8.56592 20.7964 8.63916 20.5708 8.81445 20.4439L11.7061 18.3433C11.8818 18.2163 12.1182 18.2163 12.2939 18.3433L15.1855 20.4439C15.3608 20.5708 15.4341 20.7964 15.3672 21.0024L15.2944 21.2261C15.2441 21.3804 15.1221 21.5015 14.9668 21.5493C14.0083 21.8472 13.0103 21.9976 12 21.9976ZM10.0464 20.7847C11.3247 21.0679 12.6753 21.0679 13.9536 20.7847L12 19.3657L10.0464 20.7847Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 19.2476C11.7236 19.2476 11.5 19.0239 11.5 18.7476V14.8013C11.5 14.5249 11.7236 14.3013 12 14.3013C12.2764 14.3013 12.5 14.5249 12.5 14.8013V18.7476C12.5 19.0239 12.2764 19.2476 12 19.2476Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.606 14.6519C18.5454 14.6519 18.4839 14.6411 18.4238 14.6177L14.7095 13.1665C14.4526 13.0659 14.3252 12.7759 14.4258 12.519C14.5264 12.2622 14.8159 12.1333 15.0737 12.2349L18.7881 13.686C19.0449 13.7866 19.1724 14.0767 19.0718 14.3335C18.9946 14.5308 18.8057 14.6519 18.606 14.6519Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.7866 9.80127C13.6802 9.80127 13.5732 9.76709 13.4824 9.69775C13.2632 9.5288 13.2227 9.21533 13.3906 8.99658L15.5996 6.12549C15.7676 5.90576 16.0811 5.86572 16.3008 6.03369C16.52 6.20264 16.5605 6.51611 16.3926 6.73486L14.1836 9.60595C14.085 9.73388 13.9365 9.80127 13.7866 9.80127Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.2129 9.80127C10.0723 9.80127 9.93213 9.7417 9.83301 9.62647L7.62403 7.04542C7.44434 6.83546 7.46924 6.52003 7.67872 6.34034C7.88868 6.16163 8.20362 6.18604 8.3838 6.39503L10.5928 8.97608C10.7725 9.18604 10.7476 9.50147 10.5381 9.68116C10.4439 9.76221 10.3281 9.80127 10.2129 9.80127Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.39404 14.6519C5.19433 14.6519 5.00537 14.5317 4.92822 14.3335C4.82763 14.0767 4.95508 13.7866 5.21191 13.686L8.92627 12.2349C9.18457 12.1333 9.47315 12.2603 9.57422 12.519C9.67481 12.7759 9.54736 13.0659 9.29053 13.1665L5.57617 14.6177C5.51611 14.6411 5.45459 14.6519 5.39404 14.6519Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FootballIcon;
